import GroupIcon from "@mui/icons-material/Group";
import { AlertTitle, Button } from "@mui/material";
import React, { DispatchWithoutAction } from "react";
import { IDisable } from "sonobello.utilities.react";

import CollapsingAlert from "../../../../Components/CollapsingAlert";

export const classNames = {
  alert: "duplicatesDispositionError",
  title: "duplicatesDispositionErrorTitle",
  actionButton: "duplicatesDispositionErrorActionButton"
};

export interface IDuplicatesDispositionAlert extends IDisable {
  /** The number of duplicates that have been detected for the customer. */
  duplicateCustomersCount: number;
  /** Flag indicating if the alert should be shown to the user. */
  show: boolean;
  /** Callback executed when the alert action is invoked. */
  onAction: DispatchWithoutAction;
}

/** An error that can be shown in the disposition step to indicate that duplicates have been found. */
const DuplicatesDispositionAlert: React.FC<IDuplicatesDispositionAlert> = ({
  disabled,
  duplicateCustomersCount,
  show,
  onAction
}) => {
  return (
    <CollapsingAlert
      className={classNames.alert}
      severity="error"
      show={show}
      action={
        <Button
          className={classNames.actionButton}
          color="inherit"
          disabled={disabled}
          startIcon={<GroupIcon />}
          onClick={onAction}
        >
          Duplicates
        </Button>
      }
    >
      <AlertTitle className={classNames.title}>
        {`${duplicateCustomersCount} duplicate ${
          duplicateCustomersCount === 1 ? "guest has" : "guests have"
        } been found. Please either:`}
      </AlertTitle>
      <div>Resolve duplicate guests.</div>
      <div>Resolve the conflicting highlighted field above.</div>
    </CollapsingAlert>
  );
};

export default DuplicatesDispositionAlert;
